interface ConfidenceMeterProps {
  confidence: string;
}

function confidenceLevel(c: string): 'high' | 'medium' | 'low' {
  const s = c.toLowerCase();
  if (s === 'high') return 'high';
  if (s === 'medium') return 'medium';
  return 'low';
}

function widthPct(level: 'high' | 'medium' | 'low'): string {
  switch (level) {
    case 'high': return '100%';
    case 'medium': return '60%';
    case 'low': return '30%';
  }
}

/**
 * Horizontal bar colored by confidence level.
 * Green = high, amber = medium, red = low.
 */
export function ConfidenceMeter({ confidence }: ConfidenceMeterProps) {
  const level = confidenceLevel(confidence);

  return (
    <div class="confidence-meter">
      <div class="confidence-meter-bar">
        <div
          class={`confidence-meter-fill ${level}`}
          style={{ width: widthPct(level) }}
        />
      </div>
      <span class="confidence-meter-label">{confidence}</span>
    </div>
  );
}
